/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList, teamList = [] }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
      team_ids: teamList,
    });
  }
}

export default new InboxMembers();
